const chatMobile = (state = {
    inputValue: '',
    editingMessageId: null
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'CHAT_MOBILE_EDIT_MESSAGE':
            return Object.assign({}, state, {
                inputValue: action.payload.text,
                editingMessageId: action.payload.messageId
            });

        case 'CHAT_MOBILE_STOP_EDIT_MESSAGE':
            return Object.assign({}, state, {
                inputValue: '',
                editingMessageId: null
            });

        default:
            return state;
    }
}

export default chatMobile;
